// Lote 94 — seletor segmentado ÚNICO do app (Agenda, Calendário, Publicações, Painel, Mensagens…):
// uma barra com divisórias entre as opções, altura confortável para o toque e o mesmo "selecionado".
//   tone="dark"  → selecionado em preto com texto dourado (padrão)
//   tone="beige" → selecionado em cinza suave (seletor de OAB) — Lote 141
//   tone="light" → selecionado em cinza suave (visões do Calendário) — Lote 141
// options: [{ key, label, count?, testid?, title?, to? }]  (to = renderiza <Link> em vez de <button>)
import { Link } from "react-router-dom";

const SEL = {
  dark: "bg-stone-900 text-gold-400 font-bold",
  beige: "bg-stone-400 text-white font-bold",   // Lote 141: cinza suave (igual ao "Perguntar")
  light: "bg-stone-400 text-white font-bold",
};

export default function Segmented({ options, value, onChange, tone = "dark", size = "md", testid, className = "", fit = false, scroll = false, ariaLabel }) {
  const h = size === "sm" ? "h-9 text-[13px]" : "h-11 text-sm";
  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      data-testid={testid}
      className={`${fit ? "inline-flex" : "flex"} ${scroll ? "overflow-x-auto" : "overflow-hidden"} rounded-xl border border-stone-300 bg-stone-100 ${className}`}
    >
      {options.map((o, i) => {
        const on = value === o.key;
        const cls = `shrink-0 ${fit ? "" : "flex-1"} ${h} px-3 sm:px-4 whitespace-nowrap inline-flex items-center justify-center gap-1.5 transition-colors ${i > 0 ? "border-l border-stone-300" : ""} ${
          on ? SEL[tone] : "text-stone-600 font-medium hover:bg-stone-200/70"
        } focus:outline-none focus-visible:ring-2 focus-visible:ring-stone-400 focus-visible:ring-inset`;
        const inner = (
          <>
            {o.label}
            {o.count != null && <span className={`text-xs tabular-nums ${on ? "opacity-80" : "text-stone-500"}`}>{o.count}</span>}
          </>
        );
        return o.to ? (
          <Link key={o.key} to={o.to} role="tab" aria-selected={on} data-testid={o.testid} title={o.title} className={cls}>{inner}</Link>
        ) : (
          <button key={o.key} type="button" role="tab" aria-selected={on} data-testid={o.testid} title={o.title} onClick={() => onChange && onChange(o.key)} className={cls}>{inner}</button>
        );
      })}
    </div>
  );
}
